import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SharedDataService } from '../../shared-data.service';

@Component({
  selector: 'app-category-select',
  templateUrl: './category-select.component.html',
  styleUrls: ['./category-select.component.scss']
})
export class CategorySelectComponent implements OnInit {

  @Input() fromComponent: string;

  @Input() sectionName: string;

  @Input() appTypes: Array<any>;

  @Input() deviderArray: Array<any>;

  @Output() selectedCategory = new EventEmitter();

  @Output() selectedCategoryA = new EventEmitter();

  filterAppType = 'ALL'

  abcd: string;

  constructor(private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    // this.abcd = JSON.stringify(this.appTypes);
    console.log('appTypes', this.appTypes);
  }

  onChange(newValue: any) {
    this.filterAppType = newValue;
    // const appType = this.sharedDataService.refactorMetadataAppTypeToOriginal(newValue);
    this.selectedCategory.next(newValue);
  }

  onDDChange(newValue: string) {
    console.log(newValue);
    this.operateTextChange(newValue);
    this.filterAppType = newValue;
    // const appType = this.sharedDataService.refactorMetadataAppTypeToOriginal(newValue);
    this.selectedCategory.next(newValue);
  }

  onDDChangeA(newValue: string) {
    console.log(newValue);
    this.operateTextChange(newValue);
    this.filterAppType = newValue;
    this.selectedCategoryA.next(newValue);
  }

  operateTextChange(newValue: string) {
    const elemId = this.fromComponent + '-' + this.sectionName + '-filterAppTypeText';
    const ddElement = document.getElementById(elemId);
    if (ddElement) {
      ddElement.textContent = newValue;
    }
  }

}
